import React from 'react'

function Babycare() {
  return (
    <>
    <div className='h-screen w-full flex justify-center items-center'>
    <div className='lg:text-9xl text-3xl font-extrabold text-myPink'>NOT IN STOCK</div>
    </div>
    </>
  )
}

export default Babycare